// extracted by mini-css-extract-plugin
export default {"button":"travel-company_button__PGF+H","admin__span":"travel-company_admin__span__6r+Ze","company":"travel-company_company__q7o3R"};